import {
  AssetVizController,
  AssetVizHeatmapDisplayState,
  AssetVizSceneConfig,
} from 'features/assetViz'
import { ASSET_VIZ_DEFAULT_CONFIG } from 'pages/reporting/shared/constants'
import { useRef, useState } from 'react'

interface AssetVizStateResult {
  drawingVizRef: React.RefObject<AssetVizController>
  heatmapSceneConfig: AssetVizSceneConfig
  aspectRatioRef: React.RefObject<number>
}

/**
 * Hook to manage AssetViz visualization state and configurations
 *
 * Provides:
 * - Ref for drawing visualizations
 * - Scene configuration
 * - Aspect ratio tracking
 *
 * @returns {AssetVizStateResult} Object containing refs and scene configurations
 */
export const useAssetVizState = (): AssetVizStateResult => {
  const drawingVizRef = useRef<AssetVizController>(null)
  const aspectRatioRef = useRef<number>(-1)

  const [heatmapSceneConfig] = useState<AssetVizSceneConfig>(() => ({
    ...ASSET_VIZ_DEFAULT_CONFIG,
    overrideCameraAspectRatio: aspectRatioRef,
    heatmapDisplayState: AssetVizHeatmapDisplayState.Sharp,
    show3D: false,
    showCompass: true,
    showFeatureLabels: true,
    invertColors: true,
    showLegend: true,
  }))

  return {
    drawingVizRef,
    heatmapSceneConfig,
    aspectRatioRef,
  }
}
